import React from 'react'
import { Text } from 'uiComponents/typography'
import { DateFormats, formatISOString } from 'utils/dates'
import { useTranslation } from 'translations'

interface RedeemedOnProps {
    value?: string
}

const RedeemedOn: React.FC<RedeemedOnProps> = ({ value }) => {
    const { t } = useTranslation()
    if (!value) {
        return (
            <Text status="processing" title={t('orders.orders.ordersTable.details.notRedeemed')}>
                {t('orders.orders.ordersTable.details.notRedeemed')}
            </Text>
        )
    }
    const formattedDate = formatISOString(value, `yyyy-MM-dd ${DateFormats.SHORT_TIME}`)

    return (
        <Text status="success" title={formattedDate}>
            {formattedDate}
        </Text>
    )
}

export default RedeemedOn
